import { __decorate, __metadata } from "tslib";
import { asyncFrame, asyncTimeout } from '@1inch-community/core/async';
import { appendClass, subscribe } from '@1inch-community/core/lit-utils';
import { css, html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { when } from 'lit/directives/when.js';
import { debounceTime, Subject, switchMap } from 'rxjs';
import './digit-animation.element';
let NumberAnimationElement = class NumberAnimationElement extends LitElement {
    constructor() {
        super(...arguments);
        this.showColorIndicator = false;
        this.renderValue = '';
        this.transition$ = new Subject();
    }
    static { this.tagName = 'inch-number-animation'; }
    static { this.styles = css `
    :host {
      display: flex;
      align-items: center;
      height: 1em;
      color: inherit;
    }

    :host(:dir(rtl)) {
      flex-direction: row-reverse;
    }

    :host(.up) {
      color: #00c853;
    }

    :host(.down) {
      color: #d50000;
    }

    .symbol {
      height: 1em;
      line-height: 1em;
      transition: color 0.1s;
    }
  `; }
    set value(value) {
        if (this.renderValue === value)
            return;
        if (this.renderValue.length === 0) {
            this.renderValue = value;
            return;
        }
        this.transition$.next(value);
    }
    connectedCallback() {
        super.connectedCallback();
        subscribe(this, [
            this.transition$.pipe(debounceTime(300), switchMap((value) => this.transition(value))),
        ], { requestUpdate: false });
    }
    render() {
        const list = this.renderValue.split('');
        return html `
      ${when(this.prefixSymbol, () => html `<span class="symbol">${this.prefixSymbol}</span>`)}
      ${repeat(list, (digit) => html `<inch-digit-animation digit="${digit}"></inch-digit-animation>`)}
      ${when(this.postfixSymbol, () => html `<span class="symbol">&nbsp;${this.postfixSymbol}</span>`)}
    `;
    }
    async transition(value) {
        const renderValueNumber = parseFloat(this.renderValue.replace(' ', ''));
        const nextValueNumber = parseFloat(value.replace(' ', ''));
        const delta = Math.abs(value.length - this.renderValue.length) + 1;
        const stubString = new Array(delta).fill('').join('\n');
        if (this.renderValue.length && value.length > this.renderValue.length) {
            this.renderValue = this.renderValue + stubString;
        }
        if (this.renderValue.length && value.length < this.renderValue.length) {
            this.renderValue = value + stubString;
        }
        if (this.renderValue.length && delta > 1) {
            await asyncFrame(10);
        }
        this.renderValue = value;
        if (!this.showColorIndicator)
            return;
        appendClass(this, {
            up: renderValueNumber < nextValueNumber,
            down: renderValueNumber > nextValueNumber,
        });
        await asyncTimeout(500);
        appendClass(this, {
            up: false,
            down: false,
        });
    }
};
__decorate([
    property({ type: String, attribute: true }),
    __metadata("design:type", String)
], NumberAnimationElement.prototype, "prefixSymbol", void 0);
__decorate([
    property({ type: String, attribute: true }),
    __metadata("design:type", String)
], NumberAnimationElement.prototype, "postfixSymbol", void 0);
__decorate([
    property({ type: Boolean, attribute: true }),
    __metadata("design:type", Object)
], NumberAnimationElement.prototype, "showColorIndicator", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], NumberAnimationElement.prototype, "value", null);
__decorate([
    state(),
    __metadata("design:type", Object)
], NumberAnimationElement.prototype, "renderValue", void 0);
NumberAnimationElement = __decorate([
    customElement(NumberAnimationElement.tagName)
], NumberAnimationElement);
export { NumberAnimationElement };
//# sourceMappingURL=number-animation.element.js.map